import React from 'react';
import { useToast } from '@/hooks/use-toast';

// Action feedback must never float over controls. Legacy notifications stay
// in document flow until dismissed; actions should prefer their own inline state.
export function Toaster() {
  const { toasts, dismiss } = useToast();
  return <section aria-label="Action messages" aria-live="polite">
    {toasts.filter(item => item.open).map(({id,title,description,action,variant}) =>
      <div key={id} role={variant === 'destructive' ? 'alert' : 'status'} className="m-4 rounded-md border border-cw bg-cw-card p-3 text-sm">
        {title && <strong>{title}</strong>}
        {description && <p>{description}</p>}
        {action}
        <button type="button" className="ml-3 underline" onClick={() => dismiss(id)}>Dismiss</button>
      </div>
    )}
  </section>;
}
